
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 19","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.82 18.874c-1.242 0-1.708-.699-1.786-1.942l-1.01-14.68C9.947.776 10.956 0 12.2 0h1.631c1.243 0 2.253.776 2.175 2.252l-.932 14.68c-.078 1.243-.621 1.942-1.864 1.942zM1.014 16.932L.004 2.252C-.073.776.936 0 2.18 0h1.63c1.243 0 2.253.776 2.175 2.252l-.932 14.68c-.078 1.243-.621 1.942-1.864 1.942h-.31c-1.321 0-1.787-.699-1.865-1.942z"}})])
          )
        }
      }
    